import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AdapterLink from '../../components/common/adapterLink';
import { Box, Typography } from '@material-ui/core';
import CommunityList from './communityList';

const CommunityCategory = ({ communityCategoryList }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {communityCategoryList &&
        communityCategoryList.map(
          (communityCategory, index) =>
            communityCategory.communities &&
            communityCategory.communities.length > 0 && (
              <Box className={classes.listMain} key={index}>
                <Box className={classes.communityHeading}>
                  <Typography align="left" variant="subtitle2" display="inline">
                    {communityCategory.title}
                  </Typography>
                </Box>
                <CommunityList
                  isShowDescription={false}
                  communityList={communityCategory.communities}
                />
                <Typography
                  align="center"
                  variant="overline"
                  display="block"
                  className={classes.allCommunityLink}
                  to={
                    (communityCategory && communityCategory.categorySlug) || ''
                  }
                  component={AdapterLink}
                >
                  View All
                </Typography>
              </Box>
            )
        )}
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  listMain: {
    overflow: 'hidden',
    background: 'white',
    borderRadius: '15px',
    marginTop: theme.spacing(2),
    padding: theme.spacing(3, 4),
  },
  communityHeading: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  allCommunityLink: {
    color: '#2793e7',
    textDecoration: 'none',
  },
  joinBtn: {
    right: 0,
  },
}));

export default CommunityCategory;
